import { VStack, Text, SimpleGrid } from '@chakra-ui/react';
import { FOOTER_LINKS } from '../../../utils/constants';
import { Link as RouterLink } from 'react-router-dom';

interface FooterLinksProps {
  columns?: number;
  spacing?: number | string;
  headingFontSize?: string | string[];
  itemFontSize?: string | string[];
}

const FooterLinks: React.FC<FooterLinksProps> = ({
  columns = 4,
  spacing = 10,
  headingFontSize = '16px',
  itemFontSize = '14px',
}) => (
  <SimpleGrid columns={columns} spacing={spacing}>
    {FOOTER_LINKS.map((section, idx) => (
      <VStack key={section.heading} align="start" spacing={2}>
        <Text
          fontWeight="medium"
          mb={1}
          fontSize={headingFontSize}
          fontFamily="marketingPage"
          color="text.lightGrey">
          {section.heading}
        </Text>
        {section.links.map((link) => (
          <Text
            as={RouterLink}
            to={link.href}
            key={link.label}
            color="text.lightGrey"
            fontSize={itemFontSize}
            fontFamily="marketingPage"
            _hover={{ color: 'whiteAlpha.900', cursor: 'pointer' }}>
            {link.label}
          </Text>
        ))}
      </VStack>
    ))}
  </SimpleGrid>
);

export default FooterLinks;
